import { Component, Input } from '@angular/core';


@Component({
  selector: 'form-history-button',
  templateUrl: './form-history-button.component.html',
  styleUrls: ['./form-history-button.component.scss']
})
export class FormHistoryButtonComponent {
  @Input() isExpanded?: boolean;
  @Input() isShowing?: boolean;
  @Input() hidden?: boolean;

  public value?: boolean;

}
